/**
 * The `system/` aggregate — three `RouteObject`s, so the file is
 * `system.routes.tsx` (plural) and the importer knows to expect an array.
 *
 * `system/` is the one area in `src/features/` whose name is a technical kind
 * rather than a product-domain noun, because these pages are not product
 * surfaces: they are the fall-through the edge and the router land on.
 *
 * **Both routes are unguarded, and that is deliberate.** They sit inside the
 * app shell — a reader here is more lost than anywhere else and the shell is
 * the only way out — but behind no guard, because bouncing an anonymous
 * visitor from a dead URL to a sign-in screen answers a question they did not
 * ask. The shell renders correctly with no session: the account menu already
 * has its anonymous label, and nothing on either page reads anything.
 *
 * The catch-all is the SAME route object under a second path rather than a
 * second definition, so `/404` and an unmatched address can never drift apart.
 * React Router ranks `*` below every literal path, so its position in this
 * array is not what makes it last.
 */
import type { RouteObject } from 'react-router-dom';

import { notFoundRoute } from './404/not-found.route';
import { serverErrorRoute } from './500/server-error.route';

export const systemRoutes: RouteObject[] = [notFoundRoute, serverErrorRoute, { ...notFoundRoute, path: '*' }];
